import models from 'public/models.json';
export default {
  name: 'ElRow',
  componentName: 'ElRow',

  props: {
    _tag: {
      type: String,
      default: 'div'
    },
    _gutter: Number,
    _type: {
      type: String,
      default: 'flex'
    },
    _justify: {
      type: String,
      default: 'start'
    },
    _align: {
      type: String,
      default: 'top'
    },
    value: {

    }
  },

  computed: {
    style() {
      const ret = {};

      if (this._gutter) {
        ret.marginLeft = `-${this._gutter / 2}px`;
        ret.marginRight = ret.marginLeft;
      }

      return ret;
    }
  },

  render(h) {
    const that = this;
    ////console.log('标签' + this._tag, '方法', this.$listeners);
    const model = models[that._tag] ? models[that._tag] : {
      event: 'input',
      prop: 'value'
    };
    return h(this._tag, {
      class: [
        'el-row',
        this._justify !== 'start' ? `is-justify-${this._justify}` : '',
        this._align !== 'top' ? `is-align-${this._align}` : '',
        { 'el-row--flex': this._type === 'flex' }
      ],
      style: this.style,
      props: {
        ...that.$attrs,
        ...that.$props,
        [model.prop]: that.value
      },
      on: {
        ...that.$listeners,
        [model.event]: function (value) {
          that.$emit('input', value)
        }
      },
    }, this.$slots.default);
  },
  mounted() {
    const self = this;
    self.$emit('mounted', self);
  }
};



// WEBPACK FOOTER //
// ./src/components/public/element-secondary/r/src/row.js